<template>
    <div class="tooltip-target-cont">
        <button
            role="button"
            type="button"
            class="tooltip-target"
            :tabindex="tabindex"
            @mouseenter="openNoOverlay($event)"
            @mouseleave="close($event)"
            @keyup.space="handleOnKeyUp($event)"
            @keyup.enter="handleOnKeyUp($event)"
            @click="openNoOverlay($event)"
            :aria-label="
                $getLocale('the_location_varies_depending_on_credit_card_sr_only')
            "></button>

        <div
            class="overlay"
            @click.stop.prevent="close($event)"
            :style="{ display: overlay ? 'block' : 'none' }"></div>
        <div
            class="tooltip"
            ref="tooltip"
            tabindex="-1"
            :id="tooltipId"
            @mouseleave="close($event)"
            @mouseenter="openNoOverlay($event)"
            @click.stop.prevent
            :style="{ display: isOpen ? 'block' : 'none' }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['aria-label', 'tabindex', 'tooltipId'],

        data: function () {
            return {
                isOpen: false,
                overlay: false,
            };
        },

        created: function () {
            window.addEventListener('keyup', (event) => {
                this.handleOnKeyUp(event);
            });
            window.addEventListener('click', (event) => {
                this.handleWindowClick(event);
            });
        },

        destroyed() {
            window.removeEventListener('keyup', (event) => {
                this.handleOnKeyUp(event);
            });
            window.removeEventListener('click', (event) => {
                this.handleWindowClick(event);
            });
        },

        methods: {
            openNoOverlay(e) {
                if (!this.isOpen) {
                    this.isOpen = true;
                    window.setTimeout(() => {
                        this.$refs.tooltip.focus();
                    }, 0);
                }
            },

            handleOnKeyUp(e) {
                if (e.id === 'info-cvv') {
                    this.openNoOverlay(e);
                }

                if (e.key === 'Escape') {
                    this.close(event);
                }
            },

            handleWindowClick(e) {
                if (
                    event.detail !== 0 &&
                    this.isOpen === true &&
                    event.target.lastChild._prevClass !== 'tooltip'
                ) {
                    this.close(event);
                }
            },

            close(e) {
                this.isOpen = false;
            },
        },
    };
</script>
